<div>
  <app-mat-spinner-overlay *ngIf="showSpinner"> </app-mat-spinner-overlay>
  <form #df="ngForm" novalidate (keydown.enter)="onsearch()">
    <div class="row m-0 col-md-12 p-0 formborder">
      <div class="col-md-3">
        <span class="required-lable"> From Date </span>
        <div class="datepicker_feild">
          <input
            [matDatepicker]="picker"
            dateConvert
            placeholder="DD/MM/YYYY"
            name="FromDate"
            id="FromDate"
            class="form-control input-text-css"
            [(ngModel)]="voucherdatefrom"
            (dateChange)="DateChange()"
            required
            #refFromDate="ngModel"
            [ngClass]="{
              'is-invalid': df.submitted && refFromDate.invalid,
              'alert-warning':
                refFromDate.invalid &&
                (refFromDate.dirty ||
                  refFromDate.touched ||
                  refFromDate.untouched)
            }"
          />
          <mat-datepicker-toggle
            matSuffix
            [for]="picker"
          ></mat-datepicker-toggle>
          <mat-datepicker #picker></mat-datepicker>
        </div>
        <!-- <input
          name="FromDate"
          [(ngModel)]="voucherdatefrom"
          id="FromDate"
          placeholder="From Date"
          class="form-control input-text-css"
          bsDatepicker
          (ngModelChange)="DateChange()"
          required
          #refFromDate="ngModel"
          [ngClass]="{
            'is-invalid': df.submitted && refFromDate.invalid,
            'alert-warning':
              refFromDate.invalid &&
              (refFromDate.dirty ||
                refFromDate.touched ||
                refFromDate.untouched)
          }"
        /> -->
      </div>
      <div class="col-md-3">
        <span class="required-lable"> To Date </span>
        <div class="datepicker_feild">
          <input
            [matDatepicker]="picker2"
            dateConvert
            placeholder="DD/MM/YYYY"
            name="ToDate"
            id="ToDate"
            class="form-control input-text-css"
            [(ngModel)]="voucherdateto"
            (dateChange)="DateChange()"
            required
            #refToDate="ngModel"
            [ngClass]="{
              'is-invalid': df.submitted && refToDate.invalid,
              'alert-warning':
                refToDate.invalid &&
                (refToDate.dirty || refToDate.touched || refToDate.untouched)
            }"
          />
          <mat-datepicker-toggle
            matSuffix
            [for]="picker2"
          ></mat-datepicker-toggle>
          <mat-datepicker #picker2></mat-datepicker>
        </div>
        <!-- <input
          name="ToDate"
          [(ngModel)]="voucherdateto"
          id="ToDate"
          placeholder="To Date"
          class="form-control input-text-css"
          bsDatepicker
          (ngModelChange)="DateChange()"
          required
          #refToDate="ngModel"
          [ngClass]="{
            'is-invalid': df.submitted && refToDate.invalid,
            'alert-warning':
              refToDate.invalid &&
              (refToDate.dirty || refToDate.touched || refToDate.untouched)
          }"
        /> -->
      </div>
      <div class="col-md-3">
        <span> Executive</span>
        <select
          name="executive"
          id="executive"
          required
          [(ngModel)]="executive"
          class="form-control input-text-css"
        >
          <option value="0">Select Executive</option>
          <option *ngFor="let cat of executiveList" [value]="cat.EmpId">
            {{ cat.EmpName }}
          </option>
        </select>
      </div>
      <div class="col-md-3">
        <span> Branch</span>
        <select
          name="BranchId"
          id="BranchId"
          #refSelectGender="ngModel"
          [(ngModel)]="Branch"
          class="form-control input-text-css"
        >
          <option value="0">Select Branch</option>
          <option *ngFor="let branch of BranchesList" [value]="branch.BranchId">
            {{ branch.Branch_Name }}
          </option>
        </select>
      </div>

      <div class="col-md-3">
        <span> Application No. </span>
        <input
          name="SearchApplication_No"
          [(ngModel)]="SearchApplication_No"
          id="SearchApplication_No"
          placeholder="Application No."
          class="form-control input-text-css"
        />
      </div>
      <div class="col-md-3">
        <span> Loan A/C No. </span>
        <input
          name="SearchLoanAcNo"
          [(ngModel)]="SearchLoanAcNo"
          id="SearchLoanAcNo"
          placeholder="Loan A/C No."
          class="form-control input-text-css"
        />
      </div>

      <div class="col-md-3">
        <span> Source Type </span>
        <select
          name="SelectSourceType"
          id="SelectSourceType"
          #refSelectSourceType="ngModel"
          (change)="Get_PartnerForDropdown()"
          [(ngModel)]="SelectSourceType"
          class="form-control input-text-css"
        >
          <option value="">Select Source Type</option>
          <option
            *ngFor="let lead of leadSourceDropdown"
            [value]="lead.Lead_Source"
          >
            {{ lead.Lead_Source_DisplayName }}
          </option>
        </select>
      </div>
      <div class="col-md-3">
        <span> Status </span>
        <select
          name="SelectStatus"
          id="SelectStatus"
          #refSelectSourceType="ngModel"
          [(ngModel)]="SelectStatus"
          class="form-control input-text-css"
        >
          <option value="All">All</option>
          <option value="Receipt">Receipt</option>
        </select>
      </div>

      <div class="col-md-3"  *ngIf="
            SelectSourceType == 'Agent' ||
            SelectSourceType == 'DSA' ||
            SelectSourceType == 'Dealer' ||
            SelectSourceType == 'Sales Executive' ||
            SelectSourceType == 'Telecaller Executive' ||
            SelectSourceType == 'Marketing Executive'
          ">
          <span> Source Name</span>
          <select
            name="LeadSourceName"
            id="LeadSourceName"
            #refLeadSourceName="ngModel"
            [(ngModel)]="LeadSourceName"
            class="form-control input-text-css"
            (change)="LMS_Get_DV_List()"
          >
            <option value="">Select Lead Reference</option>
            <option
              *ngFor="let partner of partnerDropdown"
              [value]="partner.PartnerId"
            >
              {{ partner.Partner_Name }}
            </option>
          </select>
      </div>

      <div class="col-md-2">
        <span>Actions</span>

        <select
          name="selectedAction"
          id="selectedAction"
          class="form-control input-text-css"
          [(ngModel)]="selectedAction"
        >
          <option value="">Select Action</option>
          <option value="view">View Data</option>
          <option value="export">Export Data</option>
        </select>
      </div>
      <div class="col-md-2">
        <button
          type="button"
          (click)="handleAction()"
          class="mt-3 btn font-size-12 button-btn"
          [disabled]="!df.form.valid"
        >
          Submit
        </button>
      </div>

      <div class="col-md-4">
        <form action="" class="search-text mt-3">
          <div class="bg-light rounded rounded-pill shadow-sm">
            <div class="input-group">
              <input
                type="text"
                id="FilterInputSearch"
                (keyup)="applyFilter($event.target.value)"
                name="FilterInputSearch"
                placeholder="What're you searching for?"
                class="form-control border-0 bg-light"
              />
              <div class="input-group-append">
                <button
                  id="button-addon1"
                  type="submit"
                  class="btn btn-link text-primary"
                >
                  <i class="fa fa-search"></i>
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </form>

  <div
    #tableContainer
    class="table-responsive table-striped mt-3"
    [hidden]="!dataSource"
    style="height: fit-content; overflow: auto"
  >
    <table
      class="table-bordered"
      matSort
      mat-table
      [dataSource]="dataSource"
      matTableExporter
      #exporter="matTableExporter"
    >
      <ng-container matColumnDef="VoucherId">
        <th mat-sort-header mat-header-cell *matHeaderCellDef class="width50">
          #
        </th>
        <td mat-cell *matCellDef="let row; let i = index" class="width50">
          {{ paginator?.pageIndex * paginator?.pageSize + (i + 1) }}
        </td>
      </ng-container>

      <ng-container matColumnDef="CaseNo">
        <th mat-sort-header mat-header-cell *matHeaderCellDef>Case No</th>
        <td mat-cell *matCellDef="let row">{{ row.CaseNo }}</td>
      </ng-container>

      <ng-container matColumnDef="Voucher_Date">
        <th mat-sort-header mat-header-cell *matHeaderCellDef>Voucher Date</th>
        <td mat-cell *matCellDef="let row">{{ row.Voucher_Date }}</td>
      </ng-container>

      <ng-container matColumnDef="Voucher_Type">
        <th mat-sort-header mat-header-cell *matHeaderCellDef>Voucher Type</th>
        <td mat-cell *matCellDef="let row">{{ row.Voucher_Type }}</td>
      </ng-container>

      <ng-container matColumnDef="Voucher_ReceiptNo_Book">
        <th mat-sort-header mat-header-cell *matHeaderCellDef>
          Receipt No Book
        </th>
        <td mat-cell *matCellDef="let row">
          <a href="javascript:void(0)" (click)="onclick_Receipt(row)">
            {{ row.Voucher_ReceiptNo_Book }}
          </a>
        </td>
      </ng-container>

      <ng-container matColumnDef="customer_name">
        <th mat-sort-header mat-header-cell *matHeaderCellDef>Customer Name</th>
        <td mat-cell *matCellDef="let row">{{ row.customer_name }}</td>
      </ng-container>

      <ng-container matColumnDef="Branch_Name">
        <th mat-sort-header mat-header-cell *matHeaderCellDef>Branch Name</th>
        <td mat-cell *matCellDef="let row">{{ row.Branch_Name }}</td>
      </ng-container>

      <ng-container matColumnDef="SourceName">
        <th mat-sort-header mat-header-cell *matHeaderCellDef>Source Name</th>
        <td mat-cell *matCellDef="let row">{{ row.SourceName }}</td>
      </ng-container>

      <ng-container matColumnDef="SourceType">
        <th mat-sort-header mat-header-cell *matHeaderCellDef>Source Type</th>
        <td mat-cell *matCellDef="let row">{{ row.SourceType }}</td>
      </ng-container>

      <ng-container matColumnDef="Installment_Amount">
        <th mat-sort-header mat-header-cell *matHeaderCellDef>
          Installment Amount
        </th>
        <td mat-cell *matCellDef="let row">{{ row.Installment_Amount }}</td>
      </ng-container>
      <ng-container matColumnDef="Interest_Overdue_Amount">
        <th mat-sort-header mat-header-cell *matHeaderCellDef>
          Interest Overdue Amount
        </th>
        <td mat-cell *matCellDef="let row">
          {{ row.Interest_Overdue_Amount }}
        </td>
      </ng-container>
      <ng-container matColumnDef="Other_Amount">
        <th mat-sort-header mat-header-cell *matHeaderCellDef>Other Amount</th>
        <td mat-cell *matCellDef="let row">{{ row.Other_Amount }}</td>
      </ng-container>

      <ng-container matColumnDef="Amount">
        <th mat-sort-header mat-header-cell *matHeaderCellDef>Total Amount</th>
        <td mat-cell *matCellDef="let row">{{ row.Amount }}</td>
      </ng-container>

      <ng-container matColumnDef="Account_Name">
        <th mat-sort-header mat-header-cell *matHeaderCellDef>Account Name</th>
        <td mat-cell *matCellDef="let row">{{ row.Account_Name }}</td>
      </ng-container>
      <ng-container matColumnDef="Collection_By">
        <th mat-sort-header mat-header-cell *matHeaderCellDef>Collection By</th>
        <td mat-cell *matCellDef="let row">{{ row.Collection_By }}</td>
      </ng-container>
      <ng-container matColumnDef="User_Name">
        <th mat-sort-header mat-header-cell *matHeaderCellDef>User Name</th>
        <td mat-cell *matCellDef="let row">{{ row.User_Name }}</td>
      </ng-container>
      <ng-container matColumnDef="CollectionExecutive">
        <th mat-sort-header mat-header-cell *matHeaderCellDef>
          Collection Executive
        </th>
        <td mat-cell *matCellDef="let row">{{ row.CollectionExecutive }}</td>
      </ng-container>

      <ng-container matColumnDef="Voucher_CreateOn">
        <th mat-sort-header mat-header-cell *matHeaderCellDef>
          Voucher Create On
        </th>
        <td mat-cell *matCellDef="let row">{{ row.Voucher_CreateOn }}</td>
      </ng-container>
      <ng-container matColumnDef="Mode_of_Payment">
        <th mat-sort-header mat-header-cell *matHeaderCellDef>
          Mode of Payment
        </th>
        <td mat-cell *matCellDef="let row">{{ row.Mode_of_Payment }}</td>
      </ng-container>
      <ng-container matColumnDef="Ref_No">
        <th mat-sort-header mat-header-cell *matHeaderCellDef>
          Ref No
        </th>
        <td mat-cell *matCellDef="let row">{{ row.Ref_No }}</td>
      </ng-container>
      <ng-container matColumnDef="Voucher_Narration">
        <th mat-sort-header mat-header-cell *matHeaderCellDef>Narration</th>
        <td mat-cell *matCellDef="let row">{{ row.Voucher_Narration }}</td>
      </ng-container>
      <ng-container matColumnDef="Location">
        <th mat-sort-header mat-header-cell *matHeaderCellDef>Location</th>
        <td mat-cell *matCellDef="let row">
          <a
            *ngIf="
              row.Loaction != '' && row.Loaction != null && row.Loaction != ','
            "
            [href]="'http://maps.google.com/maps?q=' + row.Loaction"
            target="_blank"
            ><i class="fa-solid fa-location-dot"></i
          ></a>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>
  </div>

  <div class="row m-0" style="background: #fff" [hidden]="!dataSource">
    <!-- <div class="col-md-4 mt-3">
      <button class="btn font-size-12 button-btn" (click)="exportExcel()">
        <i class="fa fa-file-export mr-1" style="font-size: medium; cursor: pointer"></i>
        Export
      </button>
    </div> -->
    <div class="col-md-8">
      <!-- <mat-paginator
        [length]="totalRecords"
        [pageSize]="pageSize"
        showFirstLastButtons
        (page)="onPageChange($event)"
      >
      </mat-paginator> -->
      Total Record {{ totalRecords }}
      <mat-paginator
        [pageSize]="50"
        [pageSizeOptions]="[50, 100, 500]"
        showFirstLastButtons
      >
      </mat-paginator>
    </div>
  </div>
</div>

<div
  class="modal fade in"
  id="ReceiptPrint"
  tabindex="-1"
  role="dialog"
  aria-labelledby="myModalLabel"
  data-backdrop="false"
  style="background-color: rgba(0, 0, 0, 0.5); overflow: auto"
>
  <div class="modal-dialog modal-xl modal-dialog-centered" role="document">
    <div
      cdkDrag
      cdkDragRootElement=".cdk-overlay-pane"
      class="modal-content"
      style="width: 780px"
    >
      <div
        cdkDragHandle
        class="modal-header"
        style="padding: 2px; border: none"
      >
        <h6 class="modal-title" id="myModalLabel" name="myModalLabel">
          Receipt Detail
        </h6>
        <button
          type="button"
          class="close"
          (click)="OnCloseVoucherModel()"
          aria-label="Close"
        >
          <span aria-hidden="true">
            <i class="far text-black fa-times-circle"></i>
          </span>
        </button>
      </div>
      <div class="modal-body">
        <div id="ReceiptBillPrint">
          <div class="invoice">
            <div class="header">
              <h2>Receipt</h2>
            </div>
            <div class="company-info">
              <div class="logo">
                <!-- Your company logo here -->
                <img *ngIf="!CompanyInformation?.CompanyLogo_ReceiptPrint" src="{{ CompanyProfileBaseUrl }}logo.png" />
                <img *ngIf="CompanyInformation?.CompanyLogo_ReceiptPrint" src="{{ CompanyLogoUrl + CompanyInformation?.CompanyLogo_ReceiptPrint }}" />
              </div>
              <div class="info">
                <ng-container
                  *ngIf="
                    CompanyInformation?.CompanyName_ReceiptPrint;
                    else defaultFields
                  "
                >
                  <p
                    class="company-name"
                    *ngIf="CompanyInformation?.CompanyName_ReceiptPrint"
                  >
                    <strong>{{
                      CompanyInformation?.CompanyName_ReceiptPrint
                    }}</strong>
                  </p>
                  <div class="company-details">
                    <span
                      *ngIf="CompanyInformation?.CompanyAddress_ReceiptPrint"
                    >
                      {{ CompanyInformation?.CompanyAddress_ReceiptPrint }}
                    </span>
                    <span *ngIf="CompanyInformation?.CompanyGSTNo_ReceiptPrint">
                      GST No.:
                      {{ CompanyInformation?.CompanyGSTNo_ReceiptPrint }}
                    </span>
                    <span *ngIf="CompanyInformation?.CompanyPhone_ReceiptPrint">
                      Phone No.:
                      {{ CompanyInformation?.CompanyPhone_ReceiptPrint }}
                    </span>
                    <span *ngIf="CompanyInformation?.CompanyEmail_ReceiptPrint">
                      Email Id:
                      {{ CompanyInformation?.CompanyEmail_ReceiptPrint }}
                    </span>
                  </div>
                </ng-container>

                <ng-template #defaultFields>
                  <p
                    class="company-name"
                    *ngIf="CompanyInformation?.CompanyName"
                  >
                    <strong>{{ CompanyInformation?.CompanyName }}</strong>
                  </p>
                  <div class="company-details">
                    <span *ngIf="CompanyInformation?.CompanyAddress">
                      {{ CompanyInformation?.CompanyAddress }}
                    </span>
                    <span *ngIf="CompanyInformation?.CompanyGSTNo">
                      GST No.: {{ CompanyInformation?.CompanyGSTNo }}
                    </span>
                    <span *ngIf="CompanyInformation?.CompanyPhoneNo">
                      Phone No.: {{ CompanyInformation?.CompanyPhoneNo }}
                    </span>
                    <span *ngIf="CompanyInformation?.ComapnyEmail">
                      Email Id: {{ CompanyInformation?.ComapnyEmail }}
                    </span>
                  </div>
                </ng-template>
              </div>
              <div class="invoice-no">
                <span
                  ><strong
                    >Receipt No.:{{ CompanyInformation?.Receipt_No }}</strong
                  ></span
                >
                <span
                  ><strong
                    >Receipt Date:
                    {{ CompanyInformation?.Voucher_Date }}</strong
                  ></span
                >
              </div>
            </div>

            <!-- <hr /> -->
            <div class="party-info">
              <div class="party-details">
                <span><strong>Branch Address:-</strong></span>
                <br />
                <span>{{ CompanyInformation?.Branch_Name }}</span>
                <span>{{ CompanyInformation?.Branch_Address }}</span>
                <span>Phone NO.:{{ CompanyInformation?.Branch_PhoneNo }}</span>
                <span>GST No.:{{ CompanyInformation?.Branch_GSTNo }}</span>
                <span>Email ID:{{ CompanyInformation?.Branch_Email }}</span>
              </div>
              <!-- <div class="invoice-details">
                <p><strong>Invoice No.: INV123</strong></p>
                <p><strong>Invoice Date: 2023-07-07</strong></p>
              </div> -->
              <div class="invoice-details">
                <span><strong>Customer Address:-</strong></span>
                <span
                  ><strong
                    >Loan No./Application No:{{
                      CompanyInformation?.LoanAcNo
                    }}</strong
                  ></span
                >
                <span>{{ CompanyInformation?.Customer_Name }}</span>
                <span>Address:{{ CompanyInformation?.Customer_Address }}</span>
                <span
                  >Phone no.:{{ CompanyInformation?.Customer_PhoneNo }}</span
                >
                <span>GST No.:{{ CompanyInformation?.Customer_GSTNo }}</span>
                <span>Email ID:{{ CompanyInformation?.Customer_Email }}</span>
              </div>
            </div>
            <table class="invoice-table">
              <thead>
                <tr>
                  <th colspan="6" style="text-align: left">
                    Particulars(Descriptions & Specifications)
                  </th>
                  <th style="text-align: center">HSN</th>
                  <th style="text-align: center">Amount</th>
                  <th style="text-align: center">SGST</th>
                  <th style="text-align: center">CGST</th>
                  <th style="text-align: center">IGST</th>
                  <th style="text-align: center">Total</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let x of TableData; let i = index">
                  <td style="text-align: left" colspan="6">
                    {{ x.ChargeHeadCategory }}
                  </td>

                  <td></td>
                  <td style="text-align: right">₹ {{ x.Amount }}</td>
                  <td style="text-align: right">₹ {{ x.SGST }}</td>
                  <td style="text-align: right">₹ {{ x.CGST }}</td>
                  <td style="text-align: right">₹ {{ x.IGST }}</td>
                  <td style="text-align: right">₹ {{ x.Total }}</td>
                </tr>
              </tbody>
              <tfoot>
                <tr>
                  <th colspan="6" style="text-align: right">Total:</th>
                  <th></th>
                  <th>
                    <span *ngIf="+totaltypewisemodal('Amount') != 0">
                      ₹ {{ totaltypewisemodal("Amount") }}
                    </span>
                  </th>
                  <th>
                    <span *ngIf="+totaltypewisemodal('SGST') != 0">
                      ₹ {{ totaltypewisemodal("SGST") }}
                    </span>
                  </th>
                  <th>
                    <span *ngIf="+totaltypewisemodal('CGST') != 0">
                      ₹ {{ totaltypewisemodal("CGST") }}
                    </span>
                  </th>
                  <th>
                    <span *ngIf="+totaltypewisemodal('IGST') != 0">
                      ₹ {{ totaltypewisemodal("IGST") }}
                    </span>
                  </th>
                  <th>
                    <span *ngIf="+totaltypewisemodal('Total') != 0">
                      ₹ {{ totaltypewisemodal("Total") }}
                    </span>
                  </th>
                </tr>
              </tfoot>
            </table>

            <div class="Total-Amount">
              <p>Amount In Word:- ₹ {{ AmountInWord }} only</p>
            </div>

            <div class="footer">
              <div class="created">
                <span style="margin-bottom: 10px"
                  >Narration:-{{ CompanyInformation?.Voucher_Narration }}</span
                >
                <span
                  >Mode of Payment:-Being
                  {{ CompanyInformation?.Mode_of_Payment }}
                  <span>{{ CompanyInformation?.Voucher_Cheque_or_RefNo }}</span>
                </span>
                <span id="createdOn"
                  >Created On:-{{ CompanyInformation?.CreateOn }}</span
                >
                <span>Created By:-{{ CompanyInformation?.CreateBy }}</span>
              </div>
              <div class="signature">
                <span>{{ CompanyInformation?.CompanyName }}</span>
                <span id="sign"><strong>Authorised Signatory</strong></span>
              </div>
            </div>
          </div>
        </div>
        <div class="text-right mt-2 mb-2">
          <button
            type="button"
            class="btn font-size-12 button-btn ml-2"
            (click)="PrintDoc('ReceiptBillPrint', 'Receipt Bill')"
          >
            Print
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
